import { FormFieldTypes } from "../../../data/formFieldType";
import ProductList from "../components/ProductList";


export const ProductsApplicationDetailsData = {
  name: "ProductsApplicationDetails",
  initialState: {
    MainContactPerson: null,
    MainContactPhone: '',
    MainContactEmailAddress: '',
    ApplicantsRole: null,
    CriteriaSelected: null,
    ProductCategory: null,
    ProductClassification: null,
    ProductCertificationStandard: null,
    ProductName: "",
    ProductDescription: "",
    ManufacturerName: "",
    ManufacturerAddress: "",
    SameAsManufacturer: false,
    ManufacturingPlantName: "",
    ManufacturingPlantAddress: "",
    PlaceOfManufacturing: null,
  },
  formFields: [
    {
      id: "MainContactPerson",
      lable: "Main Contact Person",
      Field_Name: "Main Contact Person",
      fieldType: FormFieldTypes.SELECT,
      dataField: "MainContactPerson",

      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "MainContactPhone",
      lable: "Main Contact Phone",
      Field_Name: "Main Contact Phone",
      fieldType: FormFieldTypes.INPUT,
      dataField: "MainContactPhone",

      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "MainContactEmailAddress",
      lable: "Main Contact Email Address",
      Field_Name: "Main Contact Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "MainContactEmailAddress",

      fieldSetting: {
        placeholder: "",
        allowSpace: false,
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "ApplicantsRole",
      lable: "Applicant's Role",
      Field_Name: "Applicant's Role",
      fieldType: FormFieldTypes.SELECT,
      dataField: "ApplicantsRole",

      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "CriteriaSelected",
      lable: "Criteria Selected",
      Field_Name: "Criteria Selected",
      fieldType: FormFieldTypes.SELECT,
      dataField: "CriteriaSelected",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "ProductDetails",
      lable: "",
      Field_Name: "Product Details",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "ProductDetails",
      fieldSetting: {
        formTitle: "Product Details",
      },
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "serviceCategory",
      lable: "Category (L1) ",
      Field_Name: "Category (L1)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "serviceCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-4 mb-3" },
    },

    {
      id: "subCategory",
      lable: "Sub Category (L2)",
      Field_Name: "Sub Category (L2)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "subCategory",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-4 mb-3" },
    },
    {
      id: "productType",
      lable: "Type (L3)",
      Field_Name: "Type (L3)",
      fieldType: FormFieldTypes.SELECT,
      dataField: "productType",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isSearchable: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-4 mb-3" },
    },

    {
      id: "searchEmailButton",
      fieldType: FormFieldTypes.COMPONENT,
      additionalComponent: <ProductList />,
      style: {
        containerCss: "col-md-12 mb-3",
      },
    },
    {
      id: "productCateloueName",
      lable: "Product Catalogue (please upload in PDF, JPG, JPEG, PNG. Max 5MB)",
      Field_Name: "Product Catalogue",
      fieldType: FormFieldTypes.FILE,
      dataField: "productCateloueName",
      fieldSetting: {
        // presentFileName: null,
        placeholder: "",
        isDownloadable: false,
        acceptedFiles: ".jpg,.png,.jpeg,.pdf",
        imageCrop: true,
        viewImage: false,
        maxFileSizeInKB: 5000,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "productPictureName",
      lable: "Product Picture (please upload in JPG, JPEG, PNG. Max 5MB)",
      Field_Name: "Product Picture",
      fieldType: FormFieldTypes.FILE,
      dataField: "productPictureName",
      fieldSetting: {
        // presentFileName: null,
        placeholder: "",
        isDownloadable: false,
        acceptedFiles: ".jpg, .png, .jpeg",
        imageCrop: true,
        viewImage: true,
        maxFileSizeInKB: 5000,
      },
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },

    {
      id: "productsGreenFeatures",
      lable: "Products Green Features",
      Field_Name: "Products Green Features",
      subLabelName: "(e.g. low VOC level, energy saving properties, recyclability, usage of recycled content, etc.)",
      fieldType: FormFieldTypes.INPUT,
      dataField: "productsGreenFeatures",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: { containerCss: "col-md-12 mb-4 product-feature" },
    },
    {
      id: "ManufacturerDetails",
      lable: "",
      Field_Name: "Manufacturer Details",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "ManufacturerDetails",
      fieldSetting: {
        formTitle: "Manufacturer Details",
      },
      style: {
        containerCss: "custom-grid",
      },
    },
    {
      id: "ManufacturerName",
      lable: "Name of Manufacturer",
      Field_Name: "Name of Manufacturer",
      fieldType: FormFieldTypes.INPUT,
      dataField: "ManufacturerName",

      fieldSetting: {
        placeholder: "Enter Manufacturer Name",
      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "ManufacturerAddress",
      lable: "Address of Manufacturer",
      Field_Name: "Address of Manufacturer",
      fieldType: FormFieldTypes.INPUT,
      dataField: "ManufacturerAddress",

      fieldSetting: {
        placeholder: "Enter Manufacturer Address",
      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "SameAsManufacturer",
      lable: "Same as Manufacturer",
      Field_Name: "Same as Manufacturer",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "SameAsManufacturer",

      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        // isDisable: true,
      },

      style: {
        containerCss: "col-12 mt-2",
      },
    },

    {
      id: "ManufacturingPlantName",
      lable: "Name of Manufacturing Plant",
      Field_Name: "Name of Manufacturing Plant",
      fieldType: FormFieldTypes.INPUT,
      dataField: "ManufacturingPlantName",

      fieldSetting: {
        placeholder: "Enter Manufacturing Plant Name",
      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "ManufacturingPlantAddress",
      lable: "Address of Manufacturing Plant",
      Field_Name: "Address of Manufacturing Plant",
      fieldType: FormFieldTypes.INPUT,
      dataField: "ManufacturingPlantAddress",

      fieldSetting: {
        placeholder: "Enter Manufacturing Plant Address",
      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },

    {
      id: "PlaceOfManufacturing",
      lable: "Place of Manufacturing",
      Field_Name: "Place of Manufacturing",
      fieldType: FormFieldTypes.SELECT,
      dataField: "PlaceOfManufacturing",

      fieldSetting: {
        placeholder: "Select Country",
        options: [
          {
            label: "Singapore",
            value: "Singapore",
          },
          {
            label: "India",
            value: "India",
          },
          {
            label: "Malaysia",
            value: "Malaysia",
          },
        ],
      },

      validation: {
        required: true,
      },

      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};

export const AuditlogData = {
  name: "AdditionalInfo",
  initialState: {
    searchByDescription: null,
    dateRange: null,
    updatedBy: null,
  },
  formFields: [
    {
      id: "searchByDescription",
      lable: "Search by Description",
      Field_Name: "Search by Description",
      fieldType: FormFieldTypes.INPUT,
      dataField: "searchByDescription",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-10 mb-3 pr-0",
      },
    },

    {
      id: "dateRange",
      lable: "Date Range",
      Field_Name: "Date Range",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "dateRange",
      fieldSetting: {
        placeholder: "Select",
        // isTime: true,
        // isDisable:true,
      },
      style: {
        containerCss:
          "col-lg-3 mb-3",
      },
    },
    {
      id: "to",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "to",
      fieldSetting: {
        formTitle: "to",
      },
      style: {
        containerCss: "date-range-to",
      },
    },
    {
      id: "submittedTo",
      lable: "Submitted To",
      Field_Name: "Submitted To",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "submittedTo",
      fieldSetting: {
        placeholder: "Select",
        // isTime: true,
        // isDisable:true,
      },
      style: {
        containerCss:
          "col-lg-3 mb-3 hide-title",
      },
    },
    {
      id: "updatedBy",
      lable: "Updated By",
      Field_Name: "Updated By",
      fieldType: FormFieldTypes.SELECT,
      dataField: "updatedBy",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
